module.exports = __webpack_public_path__ + "img/form.40944e4.jpg";